import type { RecordEntityId } from '../records';

export interface AnnouncementsResponse {
  announcements: Announcement[];
  /** Opaque cursor for the next page when pagination=cursor. Absent when exhausted. */
  next?: string;
}

export interface AllowedResourcesDetail {
  id: RecordEntityId;
  name: string;
}

export interface Announcement {
  edit_history?: EditHistory[];
  app: string;
  created_at: Date;
  is_global: boolean;
  name: string;
  info: Info;
  active: boolean;
  /** Site ids for Boost/Thrive targeting until CGE-935. Derived from details on write. */
  allowed_resources?: string[];
  /** Site targets with display names. */
  allowed_resources_details: AllowedResourcesDetail[];
  key: string;
  id: string;
  position: number;
  last_modified: Date;
  type: string;
  author: Author;
  schedule?: AnnouncementSchedule;
  status: string;

  // Additional properties for table columns
  createdBy?: string;
  editBy?: string;
  sites?: string;
  scheduleStart?: Date;
  scheduleEnd?: Date;

  // Additional properties for form
  other?: string;
  contentSwitch?: string;
}

export interface EditHistory {
  date: Date;
  user: Author;
}

export interface Info {
  en: AnnouncementInfo;
  fr?: AnnouncementInfo;
}

export interface AnnouncementInfo {
  title: string;
  description: string;
  sub_text: string;
  button_text: string;
  image_url?: string;
  link?: string;
}

export interface Author {
  id: string;
  name: Name;
}

export interface Name {
  first: string;
  last: string;
}

export interface AnnouncementSchedule {
  variable: boolean;
  start_datetime?: Date | string;
  end_datetime?: Date | string;
  sites?: SiteAnnouncementSchedule[];
}

export interface SiteAnnouncementSchedule {
  id: string;
  start_datetime: Date | string;
  end_datetime: Date | string;
}

/** Form/autocomplete option shape; same as AllowedResourcesDetail. */
export type SiteOption = AllowedResourcesDetail;

// Enum for column keys
export enum ColumnKeys {
  IMAGE = 'image',
  NAME = 'name',
  STATUS = 'status',
  APP = 'app',
  TYPE = 'type',
  SITES = 'sites',
  SCHEDULE_START = 'scheduleStart',
  SCHEDULE_END = 'scheduleEnd',
  CREATED_AT = 'created_at',
  CREATED_BY = 'createdBy',
  LAST_MODIFIED = 'last_modified',
  EDIT_BY = 'editBy',
  POSITION = 'position',
  ACTIVE = 'active',
}

export enum AnnouncementViews {
  LIVE = 'live',
  PAST = 'past',
  DRAFT = 'draft',
}

export enum AnnouncementStatus {
  PUBLISHED = 'published',
  DRAFT = 'draft',
}
